
// Scrollbar Start
class SliderScrollbar {
  constructor(slider) {
    this.slider = slider;
    this.isMobile = window.matchMedia('(max-width: 767px)').matches;
    this.init();
    window.addEventListener('resize', () => this.handleResize());
  }

  handleResize() {
    const newIsMobile = window.matchMedia('(max-width: 767px)').matches;
    if (newIsMobile !== this.isMobile) {
      this.isMobile = newIsMobile;
      this.recreateScrollbar();
    }
  }

  recreateScrollbar() {
    const existing = this.slider.parentNode.querySelector('.scrollbar-wrapper');
    if (existing) existing.remove();
    this.createScrollbar();
  }

  init() {
    this.createScrollbar();
  }

  createScrollbar() {
    const scrollbarWrap = document.createElement('div');
    scrollbarWrap.className = 'scrollbar-wrapper';

    const scrollbar = document.createElement('div');
    scrollbar.className = 'slider-scrollbar';

    const thumb = document.createElement('div');
    thumb.className = 'slider-scrollbar__thumb';

    scrollbar.appendChild(thumb);
    scrollbarWrap.appendChild(scrollbar);

    this.slider.parentNode.insertBefore(scrollbarWrap, this.slider.nextSibling);

    // Update thumb on scroll
    this.slider.addEventListener('scroll', () => {
      this.updateThumb(thumb);
    });

    // Click anywhere on scrollbar to jump
    scrollbar.addEventListener('click', (e) => {
      this.handleScrollbarClick(e, scrollbar);
    });

    this.updateThumb(thumb);
  }

  updateThumb(thumb) {
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    
    if (maxScroll <= 0) {
      thumb.style.width = "100%";
      thumb.style.left = "0%";
      return;
    }

    // Calculate thumb width (proportional to visible area)
    const thumbWidth = (this.slider.clientWidth / this.slider.scrollWidth) * 100;
    thumb.style.width = `${Math.max(10, thumbWidth)}%`; // Minimum 10% width

    // Calculate thumb position
    const scrollRatio = this.slider.scrollLeft / maxScroll;
    const maxThumbPosition = 100 - thumbWidth;
    const thumbPosition = scrollRatio * maxThumbPosition;
    
    thumb.style.left = `${thumbPosition}%`;
  }

  handleScrollbarClick(e, scrollbar) {
    const rect = scrollbar.getBoundingClientRect();
    const clickRatio = (e.clientX - rect.left) / rect.width;
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    
    this.slider.scrollTo({
      left: clickRatio * maxScroll,
      behavior: 'smooth'
    });
  }
}

function initCustomScrollbars(context = document) {
  context.querySelectorAll('.grid--slider[data-custom-dots="true"], .grid--mobile-slider[data-custom-dots="true"]').forEach((el) => {
    if (!el.dataset.sliderInit) {
      new SliderScrollbar(el);
      el.dataset.sliderInit = "true";
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initCustomScrollbars();

  setTimeout(() => {
    const recentProductsSection = document.querySelector('.recent__content[data-grid-slider]');
    if (recentProductsSection) {
      initCustomScrollbars();
      console.log("Reinit recommended section!");
    }
  }, 2000);
});

document.addEventListener("shopify:section:load", (e) => {
  initCustomScrollbars(e.target);
});
// end Scrollbar


// Upsell flickity Slider
// let flkty;

// document.addEventListener('DOMContentLoaded', () => {
//   const slider = document.querySelector('.product-list-upsell-slider');
//   if (!slider) return;

//   flkty = new Flickity(slider, {
//     wrapAround: true,
//     pageDots: false,
//     prevNextButtons: false,
//     cellAlign: 'left',
//     cellSelector: 'quick-add-product'
//   });

//   document.querySelector('.flickity-prev')?.addEventListener('click', () => flkty.previous());
//   document.querySelector('.flickity-next')?.addEventListener('click', () => flkty.next());
// });

// document.querySelectorAll('.hide_upsell-product').forEach(button => {
//   button.addEventListener('click', function(e) {
//     e.preventDefault();
//     const quickAdd = this.closest('quick-add-product');
//     const upsellBlock = this.closest('.cart-block-upsell');
//     if (!quickAdd || !flkty || !upsellBlock) return;

//     flkty.remove(quickAdd);
    
//     if (flkty.cells.length === 0) {
//       upsellBlock.style.display = 'none';
//     }
    
//     flkty.resize();
//   });
// });


// Product page image zoom feature

// const zoomContainers = document.querySelectorAll('product-images .product__slides .product__slide .image-wrapper');

// if(zoomContainers){
//    zoomContainers.forEach((container) => {
//     const img = container.querySelector('img');
  
//     container.addEventListener('mousemove', (e) => {
//       container.style.cursor = "crosshair";
//       const rect = container.getBoundingClientRect();
//       const x = e.clientX - rect.left;
//       const y = e.clientY - rect.top;
      
//       img.style.transformOrigin = `${x}px ${y}px`;
//       img.style.transform = 'scale(2)';
//     });
  
//     container.addEventListener('mouseleave', () => {
//       container.style.cursor = "default";
//       img.style.transform = 'scale(1)';
//     });
//   }); 
// }

(function() {
// Select all elements with the 'data-header-expanded' attribute
const headerElements = document.querySelectorAll('[data-header-expanded]');
const mainHeader = document.querySelector('header')
  
// Function to update the attribute based on scroll position
function updateHeaderExpanded() {
    const isAtTop = window.scrollY === 0;

    headerElements.forEach(headerElement => {
        if (isAtTop) {
            headerElement.setAttribute('data-header-expanded', 'true');
          
        } else {
            headerElement.setAttribute('data-header-expanded', 'false');
        }
    });
}
//Check for Homepage
const isHP = () => {
  const currentURL = window.location.origin + window.location.pathname;
  const baseURL = window.location.origin + '/';

  console.log(currentURL, baseURL)
  return currentURL === baseURL;
}

if(isHP()) {
//Applies styles only when on HP
mainHeader.classList.add('animate-header')
// Add event listener to update on scroll
window.addEventListener('scroll', updateHeaderExpanded);

// Initial check in case the page is not loaded at the top
updateHeaderExpanded();
  
}  



// PDP Desc Read more Logic
  document.addEventListener("DOMContentLoaded", function () {
  const readMore = document.getElementById("read-more");
  const readLess = document.getElementById("read-less");
  const truncated = document.getElementById("truncated-description");
  const full = document.getElementById("full-description");

  if (readMore && readLess && truncated && full) {
    readMore.addEventListener("click", function () {
      truncated.style.display = "none";
      full.style.display = "block";
    });

    readLess.addEventListener("click", function () {
      full.style.display = "none";
      truncated.style.display = "block";
    });
  }
});
  



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".sliderow__title").forEach(function (title) {
    title.addEventListener("click", function () {
      const wrapper = this.closest(".sliderow-wrap");
      if (wrapper) {
        wrapper.classList.toggle("open");
      }
    });
  });
});






//Upsell

const removedUpsellCards = new Map();

function getUpsellProductId(card) {
  const holder = card.querySelector('[data-quick-add-holder]');
  return holder ? Number(holder.dataset.quickAddHolder) : null;
}

function reinitUpsellSlider(upsellBlock) {
  const gridSlider = upsellBlock.querySelector('grid-slider');
  if (!gridSlider) return;

  window.gridSlider = gridSlider; 

  const sliderEl = upsellBlock.querySelector('[data-grid-slider]');
  if (!sliderEl) return;

  const existing = upsellBlock.querySelector('.scrollbar-wrapper');
  if (existing) existing.remove();

  sliderEl.dataset.sliderInit = "";

  const items = sliderEl.querySelectorAll('quick-add-product');

  if (items.length <= 1) {
    return;
  }

  requestAnimationFrame(() => {
    gridSlider.dispatchEvent(new CustomEvent('theme:grid-slider:init'));
    initCustomScrollbars(upsellBlock);
  });
}

function removeUpsellCard(card) {
  const productId = getUpsellProductId(card);
  if (productId) removedUpsellCards.set(productId, card);
  card.remove();
}

async function syncUpsellWithCart() {
  console.log("syncUpsellWithCart");
  
  const upsellBlock = document.querySelector('.cart-block-upsell');
  if (!upsellBlock) return;

  try {
    const res = await fetch('/cart.js');
    if (!res.ok) return;

    const cart = await res.json();
    const cartProductIds = cart.items.map(item => item.product_id);

    upsellBlock.querySelectorAll('quick-add-product').forEach(card => {
      const productId = getUpsellProductId(card);
      if (productId && cartProductIds.includes(productId)) {
        removeUpsellCard(card);
      }
    });

    const slideContainer =
      upsellBlock.querySelector('[data-grid-slider]') || upsellBlock;

    removedUpsellCards.forEach(function (card, productId) {
      if (cartProductIds.indexOf(productId) === -1) {
        slideContainer.appendChild(card);
        removedUpsellCards.delete(productId);
      }
    });

    reinitUpsellSlider(upsellBlock);
  } catch (error) {
    console.error('Upsell sync error:', error);
  }
}

document.addEventListener('theme:product:add', (e) => {
  const button = e.detail?.button;
  if (!button) return;

  const quickAddProduct = button.closest('quick-add-product');
  if (!quickAddProduct) return;

  const upsellBlock = quickAddProduct.closest('.cart-block-upsell');
  if (!upsellBlock) return;

  removeUpsellCard(quickAddProduct);
  reinitUpsellSlider(upsellBlock);
});

document.addEventListener('theme:cart:change', syncUpsellWithCart);
document.addEventListener('theme:cart-drawer:open', syncUpsellWithCart);


// Video mute logic
function muteButton () {
  
  const toggleButtons = document.querySelectorAll('.video-mute-toggle');
  
  toggleButtons.forEach((button) => {
    // Prevent Flickity drag capture
    button.addEventListener('pointerdown', e => e.stopPropagation());
    button.addEventListener('touchstart', e => e.stopPropagation());
    
    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      console.log("clicked");
      
      
      const videoId = this.dataset.videoId;
      const video = document.getElementById(videoId);
      if (!video) return;
      
      video.muted = !video.muted;
      this.classList.toggle('is-muted', video.muted);
    });
  });
}

document.addEventListener("DOMContentLoaded", muteButton);
document.addEventListener("shopify:section:load", muteButton);





// Grid Swatches

function initGridItemSwatches(context = document) {
    context.querySelectorAll('[data-grid-item]').forEach((card) => {
        if (card.dataset.swatchInit) return;

        const swatches = card.querySelectorAll('[data-variant-url]');
        if (!swatches.length) return;

        card.dataset.swatchInit = 'true';

        const links = card.querySelectorAll('[data-product-link]');

        swatches.forEach((swatch) => {
            swatch.addEventListener('click', (event) => {
                event.preventDefault();

                const variantUrl = swatch.dataset.variantUrl;
                if (!variantUrl) return;

                swatches.forEach((el) => {
                    el.classList.toggle('swatch__button--current', el === swatch);
                });

                const variantId = swatch.dataset.variantId;
                if (variantId) {
                    card.querySelectorAll('[data-variant-id]').forEach((image) => {
                        image.classList.toggle('is-visible', image.dataset.variantId === variantId);
                    });
                }

                links.forEach((link) => {
                    link.setAttribute('href', variantUrl);
                    link.dataset.productLink = variantUrl;
                });
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', () => initGridItemSwatches());
document.addEventListener('shopify:section:load', (e) => initGridItemSwatches(e.target));
document.addEventListener('paginate:collections-loaded', (e) => initGridItemSwatches());

function normalizeVariantOptionValue(value) {
  if (value == null) return '';
  return String(value).replace(/\s*,\s*/g, ', ').replace(/\s+/g, ' ').trim();
}

function variantCardImageUrl(src, width) {
  try {
    const url = new URL(src, window.location.origin);
    url.searchParams.set('width', String(width));
    return url.toString();
  } catch (e) {
    return src;
  }
}

function getVariantCardFabricSelection(root) {
  const fabricWrapper = root.querySelector('.finish-fabric--option');
  if (!fabricWrapper) return '';

  const input = fabricWrapper.querySelector(
    '[name^="options"]:checked, [name^="options"][type="hidden"]'
  );

  return input?.value ? normalizeVariantOptionValue(input.value) : '';
}

function resolveVariantCardImageSrc(map, fabricKey) {
  if (!map) return null;

  const keys = Object.keys(map);
  if (!keys.length) return null;

  if (fabricKey) {
    if (map[fabricKey]) return map[fabricKey];

    const matchedKey = keys.find(
      (key) => normalizeVariantOptionValue(key) === fabricKey
    );
    if (matchedKey) return map[matchedKey];
  }

  // No sibling match — still use an image from a variant that has this option value.
  return map[keys[0]];
}

function updateVariantCardImages(root) {
  const fabricKey = getVariantCardFabricSelection(root);

  root.querySelectorAll('.radio__button__card-image[data-variant-card-images]').forEach((container) => {
    const img = container.querySelector('img');
    if (!img) return;

    let map = null;
    try {
      map = JSON.parse(container.getAttribute('data-variant-card-images'));
    } catch (e) {
      return;
    }

    const src = resolveVariantCardImageSrc(map, fabricKey);
    if (!src) return;

    const widths = [165, 220, 330, 440];
    img.src = variantCardImageUrl(src, 440);
    img.srcset = widths.map((width) => `${variantCardImageUrl(src, width)} ${width}w`).join(', ');
  });
}

function initVariantCardImages(scope = document) {
  scope.querySelectorAll('[data-product-variants]').forEach((root) => {
    updateVariantCardImages(root);
  });
}

document.addEventListener('DOMContentLoaded', () => initVariantCardImages());
document.addEventListener('theme:variant:change', () => initVariantCardImages());
document.addEventListener('change', (event) => {
  const root = event.target?.closest?.('[data-product-variants]');
  if (!root || !event.target?.matches?.('[name^="options"]')) return;
  updateVariantCardImages(root);
});
document.addEventListener('shopify:section:load', (event) => {
  initVariantCardImages(event.target);
});


// PDP sale badge: keep 113px while scrolled; only ease to 210px at the header unstick
document.addEventListener('DOMContentLoaded', function() {
    const badge = document.querySelector('product-images .price-percent-off, .product__images > .price-percent-off');
    if (!badge) return;

    const pageHeader = document.querySelector('.page-header');
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const lookaheadMs = 500;
    const nearZone = 167;
    let isStuck = false;
    let lastY = window.scrollY;
    let lastTime = performance.now();

    const clearSaleBadgeScrollState = () => {
        isStuck = false;
        document.body.classList.remove('js__sale-badge-stuck', 'js__sale-badge-animate');
    };

    const updateSaleBadgeStuck = () => {
        if (mobileQuery.matches) {
            clearSaleBadgeScrollState();
            return;
        }

        const now = performance.now();
        const y = window.scrollY;
        const dt = now - lastTime;
        const velocity = dt > 0 ? (y - lastY) / dt : 0;
        lastY = y;
        lastTime = now;

        const headerOffset = pageHeader?.offsetTop || 0;
        const scrollingUp = velocity < 0;
        const nearUnstick = y - headerOffset <= nearZone;

        let next;
        if (scrollingUp && !nearUnstick) {
            next = true;
        } else if (scrollingUp && nearUnstick) {
            next = y + velocity * lookaheadMs > headerOffset;
        } else {
            next = y > headerOffset;
        }

        document.body.classList.toggle('js__sale-badge-animate', nearUnstick);
        if (next === isStuck) return;
        isStuck = next;
        document.body.classList.toggle('js__sale-badge-stuck', isStuck);
    };

    window.addEventListener('scroll', updateSaleBadgeStuck, { passive: true });
    mobileQuery.addEventListener('change', updateSaleBadgeStuck);
    updateSaleBadgeStuck();
});

// On page load scroll to active variant media
document.addEventListener('DOMContentLoaded', function() {
    if (!new URLSearchParams(window.location.search).has('variant')) return;

    const activeMedia = document.querySelector('[data-default-v-media]:not([hidden])');
    if (!activeMedia) return;

    window.addEventListener('load', function() {
        const stickyHeader = document.querySelector('[data-header-sticky]');
        const headerHeight = stickyHeader ? (document.querySelector('[data-header-height]')?.offsetHeight || 0) : 0;

        window.scrollTo({
            top: activeMedia.getBoundingClientRect().top + window.scrollY - headerHeight,
            behavior: 'smooth',
        });
    });
});

function parseSkuFromAlt(alt) {
    if (!alt) return { sku: '', alt: alt || '' };

    const bracket = alt.match(/\[data-sku=([^\]]+)\]/i);
    if (bracket) {
        return {
            sku: bracket[1].replace(/['"]/g, '').trim(),
            alt: alt.replace(bracket[0], '').replace(/\s{2,}/g, ' ').replace(/\s+-\s*$/, '').trim(),
        };
    }

    const plain = alt.match(/\bsku=([^\s\]]+)/i);
    if (plain) {
        return {
            sku: plain[1].replace(/['"]/g, '').trim(),
            alt: alt.replace(plain[0], '').replace(/\s{2,}/g, ' ').replace(/\s+-\s*$/, '').trim(),
        };
    }

    return { sku: '', alt };
}

function getSelectedPdpSku(root, variant) {
    if (variant && variant.sku) return String(variant.sku).trim();

    const skuEl = root.querySelector('[data-variant-sku]');
    if (skuEl) {
        const text = (skuEl.textContent || '').trim();
        const parts = text.split(':');
        if (parts.length > 1) return parts.slice(1).join(':').trim();
    }

    const productJson = root.querySelector('[data-product-json]');
    const idInput = root.querySelector('input[name="id"]');
    if (productJson && idInput) {
        try {
            const product = JSON.parse(productJson.textContent);
            const id = Number(idInput.value);
            const match = product.variants?.find((item) => Number(item.id) === id);
            if (match?.sku) return String(match.sku).trim();
        } catch (error) {
            // Fall through to empty SKU
        }
    }

    return '';
}

function hydrateSlideSkuFromAlt(gallery) {
    gallery.querySelectorAll('.product__slide').forEach((slide) => {
        const img = slide.querySelector('img');
        if (!img) return;

        const parsed = parseSkuFromAlt(img.getAttribute('alt') || '');
        if (parsed.alt !== (img.getAttribute('alt') || '')) {
            img.setAttribute('alt', parsed.alt);
        }
        if (parsed.sku && !slide.hasAttribute('data-sku')) {
            slide.setAttribute('data-sku', parsed.sku);
        }
    });
}

function ensureVisibleActiveSlide(gallery) {
    const slides = Array.from(gallery.querySelectorAll('.product__slide')).filter((slide) => !slide.hidden);
    if (!slides.length) return;

    const active = gallery.querySelector('.product__slide.media--active');
    if (active && !active.hidden) return;

    const next = slides[0];
    if (active) {
        active.classList.remove('media--active');
        active.classList.add('media--hidden');
    }
    next.classList.add('media--active');
    next.classList.remove('media--hidden');

    const mediaId = next.getAttribute('data-media-id');
    if (mediaId) {
        gallery.setAttribute('data-active-media', mediaId);
        gallery.querySelectorAll('[data-thumb-item]').forEach((thumb) => {
            const link = thumb.querySelector('[data-media-id]');
            thumb.classList.toggle('is-active', link?.getAttribute('data-media-id') === mediaId);
        });
        next.dispatchEvent(new CustomEvent('theme:media:select', {
            bubbles: true,
            detail: { id: mediaId },
        }));
    }
}

function filterProductSlidesBySku(gallery, sku) {
    if (!gallery) return;

    hydrateSlideSkuFromAlt(gallery);

    gallery.querySelectorAll('.product__slide[data-sku]').forEach((slide) => {
        const matches = slide.getAttribute('data-sku') === sku;
        slide.hidden = !matches;

        const mediaId = slide.getAttribute('data-media-id');
        if (!mediaId) return;

        const thumbLink = gallery.querySelector(`[data-thumb-link][data-media-id="${mediaId}"]`);
        const thumb = thumbLink?.closest('[data-thumb-item], .product__thumb');
        if (thumb) thumb.hidden = !matches;
    });

    gallery.querySelectorAll('[data-thumb-item][data-sku]').forEach((thumb) => {
        thumb.hidden = thumb.getAttribute('data-sku') !== sku;
    });

    ensureVisibleActiveSlide(gallery);
}

function initProductSlideSkuFilter(scope = document, variant) {
    scope.querySelectorAll('.product__page product-images, [data-section-type="product"] product-images').forEach((gallery) => {
        const root = gallery.closest('[data-section-type="product"]') || document;
        filterProductSlidesBySku(gallery, getSelectedPdpSku(root, variant));
    });
}

document.addEventListener('DOMContentLoaded', () => initProductSlideSkuFilter());
document.addEventListener('theme:variant:change', (event) => {
    const variant = event.detail?.variant;
    const section = event.target?.closest?.('[data-section-type="product"]') || document;
    initProductSlideSkuFilter(section, variant);
});
document.addEventListener('shopify:section:load', (event) => {
    initProductSlideSkuFilter(event.target);
});

function designerCtaCookieName(root) {
    return root?.getAttribute('data-cookie-name') || '';
}

function designerCtaHasCookie(name) {
    if (!name) return false;
    return document.cookie.split('; ').some((part) => part.indexOf(`${name}=`) === 0);
}

function designerCtaWriteCookie(name) {
    if (!name) return;
    document.cookie = `${name}=hidden; max-age=86400; path=/; SameSite=Lax`;
}

function initDesignerCta(scope = document) {
    scope.querySelectorAll('[data-designer-cta]').forEach((root) => {
        const name = designerCtaCookieName(root);
        if (!window.Shopify?.designMode && designerCtaHasCookie(name)) {
            root.hidden = true;
        }
    });
}

document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-designer-cta-close]');
    if (!close) return;
    const root = close.closest('[data-designer-cta]');
    if (!root) return;
    root.hidden = true;
    designerCtaWriteCookie(designerCtaCookieName(root));
});

document.addEventListener('DOMContentLoaded', () => initDesignerCta());
document.addEventListener('shopify:section:load', (event) => initDesignerCta(event.target));
